"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallTokenSign = void 0;
const IconLogo_1 = __importDefault(require("@/assets/icons/IconLogo"));
const btc_1 = __importDefault(require("@/assets/icons/btc"));
const eth_1 = __importDefault(require("@/assets/icons/eth"));
const icp_1 = __importDefault(require("@/assets/icons/icp"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TokenSign = ({ token }) => {
    return (react_1.default.createElement(TokenContainer, null,
        token === 'OGY' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IconLogo_1.default, null),
            " ",
            react_1.default.createElement("span", null, "OGY"))),
        token === 'ETH' && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement(eth_1.default, null),
            " ",
            react_1.default.createElement("span", null, "ETH"))),
        token === 'BTC' && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement(btc_1.default, null),
            " ",
            react_1.default.createElement("span", null, "BTC"))),
        token === 'ICP' && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement(icp_1.default, null),
            " ",
            react_1.default.createElement("span", null, "ICP"))),
        token === '%' && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            react_1.default.createElement("span", { style: { fontSize: '1.8em' } }, "%")))));
};
exports.default = TokenSign;
const TokenContainer = (0, styled_components_1.default)('div') `
  color: ${({ theme }) => theme.colors.TEXT};
  height: 20px;
  margin-left: 5px;
  padding: 5px 0;
  display: flex;
  font-size: 14px;
  grid-column: span 1;
  align-items: center;
  justify-items: center;
  width: fit-content;
  font-familly: promptLight, sans-serif;
`;
const SmallTokenSign = () => {
    return (react_1.default.createElement(SmallTokenContainer, null,
        react_1.default.createElement(IconLogo_1.default, null),
        " ",
        react_1.default.createElement("sup", null, "OGY")));
};
exports.SmallTokenSign = SmallTokenSign;
const SmallTokenContainer = (0, styled_components_1.default)('div') `
  color: ${({ theme }) => theme.colors.TEXT};
  max-height: 30px;
  color: dark-grey;
  padding: 3px 7px;
  margin-left: 10px;
  border-radius: 5px;
  display: flex;
  font-size: 11px;
  align-items: center;
  justify-items: center;
  width: fit-content;
  font-familly: promptLight, sans-serif;
`;
